var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 92,
    viewBox: "0 0 75 92",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11114_69200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H75V89C75 90.6569 73.6569 92 72 92H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11114_69200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1267 61.2966C35.1997 56.1369 37.0301 47.0902 32.2152 41.0908C27.4013 35.0914 17.7641 34.411 10.6911 39.5707C3.61819 44.7304 1.78879 53.7771 6.60265 59.7765C11.4176 65.7759 21.0538 66.4563 28.1267 61.2966Z",
    fill: "#33FDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6001 33.3501C21.1125 32.8603 18.5437 32.8847 16.0668 33.4216C13.5899 33.9584 11.2626 34.9953 9.24153 36.4624C1.75167 41.8188 -0.011786 52.1058 6.31025 59.9832C14.233 69.8554 32.3504 64.5994 34.9881 51.5663C36.3133 45.0315 31.7845 35.1339 23.6001 33.3501ZM34.2702 51.4355C31.7558 63.8652 14.4128 68.9296 6.89417 59.5583C2.21433 53.7222 4.01394 44.8773 10.9156 39.8424C17.5663 34.9909 27.06 35.2353 31.926 41.2966C33.0544 42.7288 33.8476 44.3752 34.252 46.1245C34.6563 47.8739 34.6625 49.6836 34.2702 51.4355Z",
    fill: "#3CCBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7506 40.7349C4.9074 45.7262 3.56088 54.1057 7.80252 59.3942C14.8574 68.1864 31.3006 63.3765 33.8171 51.5918C36.2985 39.9753 22.4706 32.9122 11.7506 40.7349ZM17.0165 63.1828C15.3387 63.1386 13.6925 62.7373 12.1982 62.0085C10.704 61.2797 9.39947 60.2416 8.38005 58.9703C7.36058 57.6992 6.65139 56.2272 6.30419 54.6616C5.95698 53.096 5.98051 51.4763 6.37304 49.9205C8.76827 38.7016 24.4319 34.1129 31.0879 42.4041C37.7439 50.6953 28.9724 63.9171 17.0165 63.1828Z",
    fill: "#3CCBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8103 46.4488L18.0759 47.6641C17.657 47.8507 17.3192 48.1704 17.1205 48.5684C16.9218 48.9664 16.8745 49.418 16.9868 49.8456C17.099 50.2732 17.3639 50.6503 17.7359 50.9121C18.1078 51.1739 18.5638 51.3042 19.0254 51.2805L22.3194 51.1059C22.781 51.0823 23.237 51.2125 23.6089 51.4743C23.9809 51.7361 24.2458 52.1132 24.358 52.5408C24.4703 52.9685 24.423 53.42 24.2243 53.818C24.0256 54.2161 23.6878 54.5358 23.2689 54.7223L20.5372 55.9364",
    stroke: "#3CCBB1",
    strokeWidth: 1.80628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7923 47.3459L17.8521 45.4229",
    stroke: "#3CCBB1",
    strokeWidth: 1.80628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4956 56.964L22.5554 55.041",
    stroke: "#3CCBB1",
    strokeWidth: 1.80628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6438 46.6356C73.8009 39.226 76.4295 26.2345 69.515 17.6191C62.6021 9.00376 48.7625 8.02659 38.6055 15.4362C28.4484 22.8457 25.8213 35.8373 32.7342 44.4527C39.6487 53.068 53.4867 54.0452 63.6438 46.6356Z",
    fill: "#33FDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1437 6.5028C53.5714 5.79942 49.8824 5.8344 46.3255 6.60537C42.7686 7.37634 39.4263 8.86539 36.524 10.9721C25.7682 18.6642 23.2358 33.4368 32.3146 44.7492C43.692 58.9262 69.7094 51.3782 73.4973 32.6621C75.4004 23.2778 68.8969 9.0644 57.1437 6.5028ZM72.4663 32.4742C68.8556 50.3239 43.9502 57.5966 33.1531 44.139C26.4326 35.7581 29.017 23.0564 38.9281 15.8259C48.4788 8.85907 62.1122 9.21004 69.1 17.9143C70.7205 19.9711 71.8595 22.3353 72.4402 24.8475C73.0209 27.3596 73.0298 29.9585 72.4663 32.4742Z",
    fill: "#3CCBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1269 17.1074C30.2997 24.2753 28.366 36.3086 34.4572 43.9031C44.5883 56.5291 68.2016 49.6219 71.8154 32.6984C75.3788 16.0167 55.5213 5.87366 40.1269 17.1074ZM47.6889 49.3438C45.2795 49.2802 42.9155 48.704 40.7697 47.6574C38.6239 46.6107 36.7505 45.1201 35.2866 43.2944C33.8226 41.469 32.8042 39.3551 32.3056 37.1069C31.807 34.8587 31.8407 32.5327 32.4044 30.2985C35.8441 14.1876 58.3378 7.5979 67.8962 19.5045C77.4545 31.4111 64.8582 50.3981 47.6889 49.3438Z",
    fill: "#3CCBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.137 25.3144L49.2103 27.0597C48.6087 27.3275 48.1237 27.7867 47.8383 28.3582C47.5529 28.9298 47.485 29.5783 47.6462 30.1924C47.8075 30.8065 48.1878 31.348 48.722 31.7239C49.2561 32.0999 49.9109 32.287 50.5739 32.253L55.3041 32.0022C55.9671 31.9683 56.6218 32.1553 57.156 32.5313C57.6902 32.9073 58.0705 33.4487 58.2317 34.0628C58.393 34.6769 58.3251 35.3254 58.0397 35.897C57.7543 36.4686 57.2692 36.9277 56.6676 37.1955L52.7449 38.9391",
    stroke: "#3CCBB1",
    strokeWidth: 2.5939,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2391 26.6023L48.8889 23.8408",
    stroke: "#3CCBB1",
    strokeWidth: 2.5939,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9932 40.4148L55.6431 37.6533",
    stroke: "#3CCBB1",
    strokeWidth: 2.5939,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3753 109.646C77.483 106.922 87.9303 90.6811 84.7106 73.3746C81.4878 56.0666 65.8199 44.246 49.7122 46.9707C33.6029 49.6954 23.1556 65.9344 26.3769 83.2424C29.5981 100.55 45.2675 112.371 61.3753 109.646Z",
    fill: "#33FDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.901 66.7601L49.5652 70.8847C48.5946 71.5175 47.8853 72.4525 47.5587 73.5294C47.2321 74.6063 47.3088 75.758 47.7754 76.787C48.2421 77.8159 49.0697 78.658 50.1164 79.1687C51.163 79.6795 52.3634 79.8271 53.5117 79.5862L61.7018 77.8532C62.85 77.6123 64.0504 77.7599 65.0971 78.2707C66.1437 78.7814 66.9713 79.6235 67.438 80.6524C67.9047 81.6814 67.9813 82.8331 67.6547 83.91C67.3282 84.9869 66.6188 85.9219 65.6483 86.5547L59.3186 90.6752",
    stroke: "#3CCBB1",
    strokeWidth: 4.59335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2257 69.8087L48.0339 65.3516",
    stroke: "#3CCBB1",
    strokeWidth: 4.59335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1879 92.0958L63.9961 87.6387",
    stroke: "#3CCBB1",
    strokeWidth: 4.59335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2304 73.2922C82.1832 56.9134 68.0687 45.3447 52.8942 46.1223C51.431 46.0757 50.1373 46.0568 46.2333 45.9971C28.1522 45.7189 16.1989 65.3016 19.3957 82.86C23.0049 101.891 45.0557 112.919 61.4704 110.146C77.8378 107.377 88.4974 90.8448 85.2304 73.2922ZM61.2856 109.161C45.494 111.831 30.0675 100.168 26.8982 83.16C23.7289 66.1521 34.0097 50.1417 49.8089 47.4694C65.6081 44.7971 81.0301 56.4605 84.1963 73.467C87.3626 90.4735 77.0818 106.485 61.2856 109.161Z",
    fill: "#3CCBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5099 107.539C45.077 107.539 32.5601 97.8778 29.7299 82.6742C26.753 66.6784 36.2533 51.6451 50.907 49.1694C65.5607 46.6938 79.9043 57.6873 82.8812 73.6817C86.049 90.7042 74.9266 107.537 57.5099 107.539ZM51.0949 50.1612C37.0124 52.5437 27.894 67.0541 30.77 82.5024C32.0303 89.7771 36.0066 96.3722 41.9657 101.071C53.974 110.301 70.0909 107.575 78.0348 94.9696C81.9352 88.6013 83.2882 81.1028 81.8441 73.8579C78.9696 58.4081 65.1788 47.7787 51.0949 50.1612Z",
    fill: "#3CCBB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarImg);
export default __webpack_public_path__ + "static/media/dollar-img.86bf47ac.svg";
export { ForwardRef as ReactComponent };